import {
  createPlatformState,
  platformAction,
  platformGetters,
  platformMutations
} from '~/helpers/store'

export default {
  state: () => createPlatformState(),
  actions: {
    async fetchContentCategories ({ commit }) {
      await platformAction({
        client: this.$api.content.categories,
        method: 'getAll',
        commit,
        logError: this.$logError,
        include: []
      })
    }
  },
  getters: {
    ...platformGetters
  },
  mutations: {
    ...platformMutations
  }
}
